<template>
  <div class="degree-product-add">
    <el-card>
      <div slot="header">
        <span class="title">{{ title }}</span>
      </div>
      <el-form ref="form" :model="form" label-width="110px" :rules="rules">
        <el-form-item label="学历类型" prop="degreeType">
          <el-select v-model="form.degreeType" placeholder="请选择学历类型" clearable>
            <el-option
              v-for="item in degreeTypeList"
              :key="item.tagName"
              :label="item.tagName"
              :value="item.tagName"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属学校" prop="schoolName">
          <el-select v-model="form.schoolName" placeholder="请选择学校" clearable>
            <el-option
              v-for="item in schoolList"
              :key="item.tagName"
              :label="item.tagName"
              :value="item.tagName"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="专业名称" prop="majorName">
          <el-input v-model="form.majorName" placeholder="请输入专业名称" clearable></el-input>
        </el-form-item>

        <el-form-item label="学制年限" prop="studyYears">
          <el-input
            v-model="form.studyYears"
            placeholder="请输入学制年限"
            clearable
            @input="handleStudyYearsInput"
          ></el-input>
        </el-form-item>

        <el-form-item label="学费" prop="price">
          <el-input
            v-model="form.price"
            placeholder="请输入学费"
            clearable
            @input="handlePriceInput"
          ></el-input>
        </el-form-item>

        <el-form-item label="报名登记表" prop="registrationFile">
          <upload-file
            v-model="form.registrationFile"
            :file-type="'.docx,.doc'"
            :limit="1"
          ></upload-file>
          <p class="upload-tip">用户学历提升报名填写资料使用的报名登记表</p>
          <p class="upload-detail">单个文件大小5MB，支持扩展名.docx,.doc，仅支持上传一个文件</p>
        </el-form-item>

        <el-form-item label="专业说明" prop="majorDesc">
          <tinymce ref="editor" v-model="form.majorDesc" :width="750" :height="300"></tinymce>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="loading" @click="handleSave">保存</el-button>
          <el-button
            v-if="productDegreeId"
            type="primary"
            :loading="publishLoading"
            @click="handlePublish"
            >发布</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import UploadFile from '@/components/UploadFile'
import Tinymce from '@/components/Tinymce'
import {
  deGreeSchoolFilter,
  deGreeTypeTagFilter,
  deGreeProductQuery,
  deGreeProductSubmit,
  deGreeProductCreate,
  deGreeProductEdit,
} from '@/api/center'
import to from 'await-to'
export default {
  name: 'DegreeProductAdd',
  components: {
    UploadFile,
    Tinymce,
  },
  data() {
    return {
      title: '创建学历商品',
      loading: false,
      publishLoading: false,
      degreeTypeList: [],
      schoolList: [],
      form: {
        degreeType: '',
        schoolName: '',
        majorName: '',
        studyYears: '',
        price: '',
        registrationFile: [],
        majorDesc: '',
      },
      rules: {
        degreeType: [{ required: true, message: '请选择学历类型', trigger: 'blur' }],
        schoolName: [{ required: true, message: '请选择学校', trigger: 'blur' }],
        majorName: [{ required: true, message: '请输入专业名称', trigger: 'blur' }],
        studyYears: [
          { required: true, message: '请输入学制年限', trigger: 'blur' },
          { validator: this.validateStudyYears, trigger: 'blur' },
        ],
        price: [
          { required: true, message: '请输入学费', trigger: 'blur' },
          { validator: this.validatePrice, trigger: 'blur' },
        ],
        registrationFile: [{ required: true, message: '请上传报名登记表', trigger: 'blur' }],
        majorDesc: [{ required: true, message: '请输入专业说明', trigger: 'blur' }],
      },
      productDegreeId: this.$route.params.productDegreeId,
    }
  },
  mounted() {
    this.getDegreeTypeList()
    this.getSchoolList()
    if (this.productDegreeId) {
      this.title = '编辑学历商品'
      this.handleGetDeGreeInfo(this.productDegreeId)
    }
  },
  methods: {
    async handleGetDeGreeInfo(productDegreeId) {
      const [res, err] = await to(deGreeProductQuery({ productDegreeId }))
      if (err) return this.$message.warning(err.msg)
      this.form = res.data
      if (this.form.registrationFormUrl) {
        this.form.registrationFile = [
          {
            docName: '报名登记表',
            url: this.form.registrationFormUrl,
            name: '报名登记表',
          },
        ]
      }
    },
    async getDegreeTypeList() {
      const [res, err] = await to(deGreeTypeTagFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.degreeTypeList = res.data
    },
    async getSchoolList() {
      const [res, err] = await to(deGreeSchoolFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.schoolList = res.data
    },
    handleSave() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          if (this.form.registrationFile.length > 0) {
            this.$set(this.form, 'registrationFormUrl', this.form.registrationFile[0].url)
          }
          if (this.productDegreeId) {
            const [, err] = await to(
              deGreeProductEdit({ ...this.form, productDegreeId: this.productDegreeId }),
            )
            if (err) return this.$message.warning(err.msg)
            this.$message.success('编辑成功')
            this.$router.push('/scenter/degreeProduct')
          } else {
            const [, err] = await to(deGreeProductCreate({ ...this.form }))
            if (err) return this.$message.warning(err.msg)
            this.$message.success('添加成功')
            this.$router.push('/scenter/degreeProduct')
          }
        } else {
          return
        }
      })
    },
    async handlePublish() {
      const [, err] = await to(deGreeProductSubmit({ productDegreeId: this.productDegreeId }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('发布成功')
      this.$router.push('/scenter/degreeProduct')
    },
    handleStudyYearsInput(val) {
      val = val.replace(/[^\d.]/g, '')
      val = val.replace(/\.{2,}/g, '.')
      const firstDot = val.indexOf('.')
      if (firstDot !== -1) {
        val = val.substring(0, firstDot + 1) + val.substring(firstDot + 1).replace(/\./g, '')
      }
      const parts = val.split('.')
      if (parts.length > 2) {
        val = parts[0] + '.' + parts[1]
      }
      if (parts[1] && parts[1].length > 1) {
        val = parts[0] + '.' + parts[1].slice(0, 1)
      }
      if (parts[0] && parts[0].length > 1 && parts[0].startsWith('0')) {
        val = val.replace(/^0+(\d)/, '$1')
      }
      this.form.studyYears = val
    },
    validateStudyYears(rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      const reg = /^\d+(\.\d{1})?$/
      if (!reg.test(value)) {
        callback(new Error('学制年限仅允许输入数字，且最多保留一位小数'))
      } else {
        callback()
      }
    },
    handlePriceInput(val) {
      val = val.replace(/[^\d.]/g, '')
      val = val.replace(/\.{2,}/g, '.')
      const firstDot = val.indexOf('.')
      if (firstDot !== -1) {
        val = val.substring(0, firstDot + 1) + val.substring(firstDot + 1).replace(/\./g, '')
      }
      const parts = val.split('.')
      if (parts.length > 2) {
        val = parts[0] + '.' + parts[1]
      }
      if (parts[1] && parts[1].length > 2) {
        val = parts[0] + '.' + parts[1].slice(0, 2)
      }
      if (parts[0] && parts[0].length > 1 && parts[0].startsWith('0')) {
        val = val.replace(/^0+(\d)/, '$1')
      }
      this.form.price = val
    },
    validatePrice(rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      const reg = /^\d+(\.\d{1,2})?$/
      if (!reg.test(value)) {
        callback(new Error('学费仅允许输入数字，且最多保留两位小数'))
      } else {
        callback()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.degree-product-add {
  .title {
    font-size: 18px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-input {
    width: 350px;
  }
  .el-select {
    width: 350px;
  }
  ::v-deep .el-upload-list {
    width: 600px;
  }
  .upload-tip {
    font-size: 14px;
    line-height: 14px;
    color: #909399;
    margin-top: 10px;
  }
  .upload-detail {
    margin-top: 10px;
    font-size: 14px;
    color: #909399;
    line-height: 14px;
  }
}
</style>
